import { BehaviorSubject } from 'rxjs';
export const getModalStore = () => {
    const getInitialState = () => ({
        isOpen: false,
        isLoading: false,
        relatedData: {}
    });
    const modalSubject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => modalSubject.subscribe(callback);
    const openModal = (relatedData = {}) => {
        modalSubject.next({
            relatedData,
            isOpen: true,
            isLoading: false
        });
    };
    const closeModal = () => {
        modalSubject.next(getInitialState());
    };
    const setIsLoading = (isLoading) => {
        modalSubject.next({
            ...modalSubject.getValue(),
            isLoading: isLoading
        });
    };
    return {
        getInitialState,
        subscribe,
        openModal,
        closeModal,
        setIsLoading
    };
};
